import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      /* Row spacing is carried by each row's own padding; zeroing the
         shared gap keeps the padding tracks exact too. */
      --block-row-gap: 0px;
    }

    .santiago-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      align-items: normal;
    }

    /* The block sets align-items: start, which would collapse the shared
       rule to the top of its grid area; stretch it so the border-bottom
       lands at the block's bottom. */
    .horizontal-rule {
      align-self: stretch;
    }

    h2 {
      padding-bottom: 0;
    }

    /* Card titles are the H3 tier (Graphik Regular 18/24 from 600px up,
       16/20 on mobile), not the element's default medium label. */
    driver-card::part(title) {
      padding-top: calc(20rem / var(--default-rem-px-count));
      font-size: var(--fs-title-small);
      line-height: var(--lh-title-small);
      letter-spacing: var(--ls-title-small);
      font-weight: var(--fw-regular);
    }

    /* 40px clears the description; stacked buttons sit 20px apart. */
    cta-button {
      padding-top: calc(40rem / var(--default-rem-px-count));
      width: calc(220rem / var(--default-rem-px-count));
    }

    cta-button + cta-button {
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    .card-cta-text {
      padding-top: calc(30rem / var(--default-rem-px-count));
    }

    img {
      max-width: 100%;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: calc(30rem / var(--default-rem-px-count));
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
      padding-bottom: calc(50rem / var(--default-rem-px-count));
    }

    .drivers {
      grid-column: 2 / 8;
      grid-row: 4;
      display: grid;
      grid-template-columns: subgrid;
      gap: calc(50rem / var(--default-rem-px-count));
    }

    /* Cards are driver-card elements; spacing is padding-based and images
       sit natural-size, centered in a bordered aspect box. */
    .driver-wrapper {
      display: flex;
      flex-direction: column;
      grid-column: span 6;
    }

    driver-card {
      --driver-card-gap: 0;
      --driver-card-image-width: auto;
      --driver-card-image-fit: initial;
    }

    driver-card::part(image) {
      width: 100%;
      aspect-ratio: 1 / 1;
      border: 0.5px solid var(--block-text-color, #222222);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /* Borderless: the fixed box goes away and each image fills the card at
       its own aspect ratio. */
    .no-image-border driver-card {
      --driver-card-image-width: 100%;
    }

    .no-image-border driver-card::part(image) {
      aspect-ratio: auto;
      border: none;
      display: block;
    }

    driver-card::part(description) {
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    .driver-wrapper {
      width: 100%;
    }

    .text-sections-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .text-section {
      padding-top: calc(14rem / var(--default-rem-px-count));
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
    }

    @media (min-width: 600px) {
      .santiago-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        align-items: start;
      }

      h2 {
        padding-bottom: calc(60rem / var(--default-rem-px-count));
      }

      /* Top-row texts share a first baseline. */
      .header {
        grid-column: 2 / 5;
        grid-row: 2;
        align-self: baseline;
        padding-bottom: 0;
      }

      .description {
        grid-column: 6 / 10;
        grid-row: 2;
        align-self: baseline;
        padding-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .drivers {
        grid-column: 2 / 14;
        grid-row: 3;
        gap: calc(2 * var(--between-column-padding))
          var(--between-column-padding);
      }
    }

    @media (min-width: 1024px) {
      .driver-wrapper {
        grid-column: span 4;
      }

      /* Cards Per Row always resolves to one of these, so the span above is
         only a guard. Card edges land on the page grid lines: halves,
         thirds or quarters of the 12 tracks. */
      .two-per-row .driver-wrapper {
        grid-column: span 6;
      }

      .three-per-row .driver-wrapper {
        grid-column: span 4;
      }

      .four-per-row .driver-wrapper {
        grid-column: span 3;
      }
    }
  `,
];
